import React, { useEffect, useRef, useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import TextField from "@mui/material/TextField";
import SimpleImageSlider from "react-simple-image-slider";
import Testimonial1 from "./Testimonial1";
import Testimonial2 from "./Testimonial2";
import Testimonial3 from "./Testimonial3";
import Testimonial4 from "./Testimonial4";
import Testimonial5 from "./Testimonial5";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Menu from "../Menu";
import { HashLink } from "react-router-hash-link";

const images = [
  {
    url: "img/project0.jpeg",
  },
  {
    url: "img/project4.jpeg",
  },
  {
    url: "img/project2.jpeg",
  },
];
const array = [
  <Testimonial1 />,
  <Testimonial2 />,
  <Testimonial3 />,
  <Testimonial4 />,
  <Testimonial5 />,
];

const Faq = () => {
  const { t, i18n } = useTranslation();

  const [index, setIndex] = useState(0);
  const prev = () => {
    if (index > 1) {
      setIndex((old) => old - 1);
    } else {
      setIndex(array.length - 1);
    }
  };
  const next = () => {
    if (index < array.length - 1) {
      setIndex((old) => old + 1);
    } else {
      setIndex(0);
    }
  };

  return (
    <div>
      <Grid container>
        <Grid item md={12}>
          <Grid container sx={{ py: 6, width: 1, display: "flex" }}>
            <Menu current={"b2b"} />
            <Grid item md={10} sx={{ px: 3, pl: 7 }}>
              <Box sx={{ pb: 1, fontSize: "22px", pb: 2 }}>
                Heslet {t("for")} B2B
              </Box>
              <Box sx={{ lineHeight: "180%", fontSize: "14px" }}>
                <div dangerouslySetInnerHTML={{ __html: t("b2bexp") }} />
              </Box>
              <Box sx={{ pt: 2 }}>
                <HashLink to="/b2b#contact" smooth>
                  <button className="custom_btn" style={{ width: 200 }}>
                    {t("Sign up")}
                  </button>
                </HashLink>
              </Box>
              <Box
                sx={{
                  pt: 5,
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    fontSize: "16px",
                    pb: 2,
                    pt: 2,
                    color: "gray",
                    fontWeight: 600,
                  }}
                >
                  {t("Featured Projects")}
                </Box>
                <SimpleImageSlider
                  width={896}
                  height={504}
                  images={images}
                  showBullets={true}
                  showNavs={true}
                  autoPlayDelay={true}
                />
              </Box>
              <Box
                sx={{
                  pt: 5,
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    fontSize: "16px",
                    pb: 2,
                    pt: 2,

                    fontWeight: 600,
                  }}
                >
                  <Box className="title" sx={{ pt: 2, pb: 1 }}>
                    {t("Why choose Heslet?")}
                  </Box>
                  <Box
                    sx={{ lineHeight: "180%", fontSize: "14px", fontWeight: 0 }}
                  >
                    {t("High quality")}
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box sx={{ width: 1, display: "flex" }}>
        <section id="contact"></section>
        <Box
          sx={{
            width: 1 / 2,
            height: "800px",
            WebkitBackgroundSize: "cover",
            backgroundImage: `url("https://images.unsplash.com/photo-1435575653489-b0873ec954e2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80")`,
          }}
        ></Box>
        <Box
          sx={{
            width: 1 / 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 6,
          }}
        >
          <Box sx={{}}>
            <Box sx={{ fontSize: "18px", fontWeight: 600 }}>
              {t("Let's discuss about partnership")}
            </Box>
            <Box sx={{ pt: 1, color: "gray" }}>
              {t(
                "Please fill out the form and submit. We will contact you as soon as possible."
              )}
            </Box>
            <Box sx={{ pt: 5 }}>
              <Box sx={{ display: "flex" }}>
                <TextField
                  variant="filled"
                  label={t("Last name")}
                  sx={{ width: 300 }}
                />
                <TextField
                  variant="filled"
                  label={t("First name")}
                  sx={{ width: 300, ml: 2 }}
                />
              </Box>
              <Box sx={{ display: "flex", mt: 3 }}>
                <TextField
                  variant="filled"
                  label={t("Company name")}
                  sx={{ width: 300 }}
                />
                <TextField
                  variant="filled"
                  label={t("Phone")}
                  sx={{ width: 300, ml: 2 }}
                />
              </Box>
              <Box sx={{ display: "flex", mt: 3 }}>
                <TextField
                  variant="filled"
                  label={t("Industryb2b")}
                  sx={{ width: 300 }}
                />
                <TextField
                  variant="filled"
                  label={t("Email")}
                  sx={{ width: 300, ml: 2 }}
                />
              </Box>

              <Box sx={{ pt: 4 }}>
                <button className="custom_btn">{t("Submit")}</button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Grid container>
        <Grid item md={12} sx={{ px: { md: 25, sm: 1 }, py: 9 }}>
          <Box className="title" sx={{ pb: 1 }}>
            <Box sx={{ pb: 2 }}>{t("What Our Clients Say About Us")}</Box>
            <Box sx={{ display: "flex", pt: 2, alignItems: "center" }}>
              <Box
                onClick={() => prev()}
                sx={{
                  fontSize: "15px",
                  // color: index === 0 ? "lightgray" : "black",
                }}
              >
                <NavigateBeforeIcon sx={{ cursor: "pointer" }} />
              </Box>

              {array[index]}

              <Box
                onClick={() => next()}
                sx={{
                  fontSize: "15px",
                  color: index === array.length - 1 ? "lihgtgray" : "black",
                }}
              >
                <NavigateNextIcon sx={{ cursor: "pointer" }} />
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Faq;
